export const DEFAULT_PROJECTS_PAGE_SIZE = 10;
export const DEFAULT_ADVERTISERS_PAGE_SIZE = 15;
export const ADVERTISERS_EXPORT_PAGE_SIZE = 500;
export const ADVERTISERS_PAGE_SIZE_ALL = -1;
export const ADVERTISERS_PAGE_SIZE_OPTIONS = [15, 25, 50, 100];
